import _ from 'lodash';
import { stringify } from 'qs';
import { fork, put, select, takeLatest } from 'redux-saga/effects';

import { getCountryCode } from '@lendingAPI/lendingAPISelector';
import { nextStep } from '@src/actions';
import {
    ALL_STEPS,
    CHECK_ELIGIBILITY_STEP_ID,
    convertActiveStepIdToStepPathName,
    PERSONAL_INFORMATION_STEP_ID
} from '@src/containers/Routes/helper/stepActiveIds.helper';
import { getQueryParams } from '@src/helpers/helpers';
import { RootState } from '@src/reducers';
import IwTracking from '@src/tracking/IwTracking';

import {
    ACTIVATE_CHECK_ELIGIBILITY_PAGE,
    REDIRECT_TO_PERSONAL_INFORMATION
} from './CheckEligibility.actions';
import { saveCustomerState } from '../AutomatedLendingDecision/AutomatedLendingDecisionUtils';
import { navigateTo } from '../Routes/Navigation.action';
import { getBasePath } from '../Routes/Navigation.selector';

function* checkEligibilityPageViewWork() {
    yield takeLatest(ACTIVATE_CHECK_ELIGIBILITY_PAGE, function* () {
        //@ts-ignore
        const { application, ui } = yield select((state: RootState) => ({
            application: state.fetched.application.payload,
            ui: state.ui
        }));

        if (ui.activeStep.id !== CHECK_ELIGIBILITY_STEP_ID) {
            yield put({
                type: 'SAVE_CUSTOMER_STATE_REQUESTED',
                state: {
                    data: {
                        application,
                        ui: _.merge({}, ui, {
                            activeStep: ALL_STEPS[4] // Set the active step to check eligibility
                        })
                    }
                }
            });
        }

        IwTracking.setLatestActiveSignupStep(CHECK_ELIGIBILITY_STEP_ID);
    });
}

function* handlePersonalInformationCTA() {
    yield takeLatest(REDIRECT_TO_PERSONAL_INFORMATION, function* () {
        const urlQuerParams = stringify(getQueryParams());
        const { state } = yield select((state) => ({
            state
        }));

        const basePath = getBasePath(state);
        const pathname = convertActiveStepIdToStepPathName(
            PERSONAL_INFORMATION_STEP_ID,
            getCountryCode(state) === 'uk'
        );

        yield put(nextStep(PERSONAL_INFORMATION_STEP_ID));
        yield* saveCustomerState(PERSONAL_INFORMATION_STEP_ID);
        yield put(
            navigateTo(
                `${basePath}/${pathname}${
                    urlQuerParams ? `?${urlQuerParams}` : ''
                }`
            )
        );
    });
}

export default [
    fork(handlePersonalInformationCTA),
    fork(checkEligibilityPageViewWork)
];
